import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import { MdClose } from "react-icons/md";
import { Button, Col, Row, Form, Card } from "react-bootstrap";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { ToastContainer, toast, Zoom } from "react-toastify";
import { motion, AnimatePresence } from 'framer-motion';
import { Stack, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

import api from '../../api';
import "../css/edit/editdoc.css";
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from "../../context/authContext";
import { Datacontext } from "../../context/dataContext";
import { AddClient } from "../client/addcllient";
import { CopyMsg } from '../others/copy_msg';
import { MSGS } from '../others/msg';

// --- CUSTOM 3-STATE TOGGLE COMPONENT ---
const ThreeStateToggle = ({ value, onChange, disabled }) => {
  const getTranslate = () => {
    if (value === 'yes') return 'translateX(38px)';
    if (value === 'no') return 'translateX(2px)';
    return 'translateX(20px)';
  };

  const getBgColor = () => {
    if (value === 'yes') return '#ece917';
    if (value === 'no') return '#8a2be2';
    return '#d1d1d1';
  };

  const getIconColor = (type) => {
    if (value === null || value === "") return '#555';
    if (type === 'no') return value === 'no' ? '#ece917' : '#4a127e';
    if (type === 'yes') return value === 'yes' ? '#4a127e' : '#ece917';
  };

  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (x < 22) onChange('no');
    else if (x > 44) onChange('yes');
    else onChange(null);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'relative', width: '66px', height: '26px',
        backgroundColor: getBgColor(), borderRadius: '13px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 8px', cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1, transition: 'all 0.3s ease',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)', border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      <span style={{ color: getIconColor('no'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✕</span>
      <span style={{ color: getIconColor('yes'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✓</span>
      
      <div style={{
        position: 'absolute', top: '2px', left: '0', width: '20px', height: '20px', 
        backgroundColor: '#fff', borderRadius: '50%', 
        transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)', transform: getTranslate(), 
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}>
        <div style={{ width: '4px', height: '4px', backgroundColor: getBgColor(), borderRadius: '50%', transition: 'background-color 0.3s' }} />
      </div>
    </div>
  );
};

// MUI Switch Styling
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28, height: 16, padding: 0, display: 'flex',
  '&:active': { '& .MuiSwitch-thumb': { width: 15 }, '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' } },
  '& .MuiSwitch-switchBase': { padding: 2, '&.Mui-checked': { transform: 'translateX(12px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1, backgroundColor: '#e7ac2d' } } },
  '& .MuiSwitch-thumb': { boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)', width: 12, height: 12, borderRadius: 6, transition: theme.transitions.create(['width'], { duration: 200 }) },
  '& .MuiSwitch-track': { borderRadius: 16 / 2, opacity: 1, backgroundColor: 'rgba(0,0,0,.25)', boxSizing: 'border-box' },
}));

const TitleCase = (str) => {
  return str ? str.toLowerCase().replace(/\s+/g, ' ').split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "";
};

export const Editnl = ({ set_docedit, id, onclose }) => {
    const { user } = useContext(AuthContext);
    const { nls, users, clients, fetchClients, fetchNl, sOffice, sZone } = useContext(Datacontext);
    const { setDim } = useContext(Dimcontext);
    const navigate = useNavigate();

    // Original Data Ref
    const [originalData, setOriginalData] = useState(null);

    // Modal & Loading States
    const [add, setAdd] = useState(false);
    const [msg, set_msg] = useState(false);
    const [activeMsgText, setActiveMsgText] = useState("");
    const [bt, setBt] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    // Form States
    const [app_No, set_App_No] = useState('');
    const [date, set_Date] = useState('');
    const [options, set_options] = useState([]);
    const [option_User, set_options_User] = useState([]);
    const [users1, set_users] = useState([]);
    const [ref, set_ref] = useState(null);
    const [owner, set_Owner] = useState(null);
    const [estimatedCost, setEstimatedCost] = useState('');
    const [status, setStatus] = useState({ click: 0, status: 'online' });

    // Streamlined Document Details
    const [docDetails, setDocDetails] = useState({
        nlno: { values: null, no: "", clicked: 0 },
        payment: { values: null, val: "", clicked: 0 },
        stamp_paper: { values: null, val: "", clicked: 0 },
        nl_received: { values: null, clicked: 0 },
        nl_delivered: { values: null, clicked: 0 }
    });

    const DATA = { zones: sZone, offices: sOffice };
    const [formData, setFormData] = useState({ zoneId: '', officeId: '' });
    const formOffices = useMemo(() => (DATA.offices || []).filter(o => o.zoneId === formData.zoneId), [formData.zoneId, DATA.offices]);

    const showToast = (message) => toast.warn(message, {
        position: "bottom-center", autoClose: 3000, theme: "dark", transition: Zoom
    });

    // --- INITIAL DATA LOAD ---
    useEffect(() => {
        const d = nls.find(item => item.id === id);
        if (d) {
            setOriginalData(d);
            set_App_No(d.application_no);
            set_Date(d.date);
            
            // Set Zone & Office safely
            const zId = sZone.find(v => v.zoneName === d.zone)?.id || "";
            setFormData({
                zoneId: zId,
                officeId: sOffice.find(o => o.officeName === d.register_office && o.zoneId === zId)?.id || ""
            });

            // Set Dropdowns
            set_users(d.managed_By ? d.managed_By.map(m => ({ value: m, label: m.toUpperCase() })) : []);
            set_ref(d.refered_by ? { value: d.refered_by, label: TitleCase(d.refered_by.name) } : null);
            set_Owner(d.owner ? { value: d.owner, label: TitleCase(d.owner.name) } : null);
            
            setStatus(d.status || { click: 0, status: 'online' });
            setEstimatedCost(d.estimated_cost || '');
            
            // Map 'values' (DB) to 'value' (Local state)
            setDocDetails({
                nlno: { values: d.nlno?.values || null, no: d.nlno?.no || "", clicked: d.nlno?.clicked || 0 },
                payment: { values: d.payment?.values|| null, val: d.payment?.val || "", clicked: d.payment?.clicked || 0 },
                stamp_paper: { values: d.stamp_paper?.values || null, val: d.stamp_paper?.val || "", clicked: d.stamp_paper?.clicked || 0 },
                nl_received: { values: d.nl_received?.values || null, clicked: d.nl_received?.clicked || 0 },
                nl_delivered: { values: d.nl_delivered?.values || null, clicked: d.nl_delivered?.clicked || 0 }
            });
        }
    }, [id, nls, sOffice, sZone]);

    useEffect(() => {
        if (originalData) {
            // If Step 1 is complete but Step 2 is NOT complete, jump to Step 2
            if (isStep1Complete && !isStep2Complete) {
                setCurrentStep(2);
            } 
            // If both are complete or both are incomplete, default to Step 1
            else {
                setCurrentStep(1);
            }
        }
        // We only want this to run once when the data is initially loaded
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [originalData]);

    const get_customer = useCallback(() => {
        if (!clients) return;
        set_options(clients.map(v => ({ value: v, label: `${v.name?.toUpperCase() || 'N/A'} - ${v.nick_name || ""} - ${v.mobile || ''}` })));
    }, [clients]);

    const get_User = useCallback(() => {
        if (!users) return;
        set_options_User(users.map(u => ({ value: u.name, label: u.name?.toUpperCase() || 'UNKNOWN' })));
    }, [users]);

    useEffect(() => { get_User(); get_customer(); }, [get_User, get_customer]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'zoneId') setFormData({ zoneId: value, officeId: '' });
        else setFormData({ ...formData, [name]: value });
    };

    const handleDocToggleChange = (field, newValue) => {
        setDocDetails(prev => ({
            ...prev,
            [field]: { ...prev[field], values: newValue }
        }));
    };

    // Role-based toggle lock
    const canToggle = (field) => {
        if (user?.role === "user" && docDetails[field].clicked >= 1) return false;
        return true;
    };

    const format = (d) => {
        if (!d) return '';
        const dt = new Date(d._seconds ? d._seconds * 1000 : d);
        return `${dt.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" })}`;
    };

    // --- STEPPER VALIDATION ---
    const isStep1Complete = useMemo(() => {
        return formData.zoneId && formData.officeId && users1.length > 0 && !!ref?.value && !!owner?.value;
    }, [formData, users1, ref, owner]);

    const isStep2Complete = useMemo(() => {
        const hasCost = !!estimatedCost;
        
        let hasPrimaryDocDetails = false;
        if (status.status === 'online') {
            hasPrimaryDocDetails = docDetails.nlno.values=== 'no' || (docDetails.nlno.values === 'yes' && !!docDetails.nlno.no);
        } else {
            const nlno = !!docDetails.nlno.values
            const payValid = docDetails.payment.values === 'no' || (docDetails.payment.values === 'yes' && !!docDetails.payment.val);
            const stampValid = docDetails.stamp_paper.values === 'no' || (docDetails.stamp_paper.values=== 'yes' && !!docDetails.stamp_paper.val);
            hasPrimaryDocDetails = payValid && stampValid && nlno;
        }

        const hasReceived = !!docDetails.nl_received.values; 
        const hasDelivered = !!docDetails.nl_delivered.values;

        return hasPrimaryDocDetails && hasCost && hasReceived && hasDelivered;
    }, [status.status, docDetails, estimatedCost]);

    const validateMandatory = () => {
        if (!formData.zoneId || !formData.officeId || users1.length === 0) {
            showToast("Application Details are mandatory!"); return false;
        }
        if (status.status === 'online' && docDetails.nlno.values === 'yes' && !docDetails.nlno.no) {
            showToast("Please enter the mandatory CCA Number."); return false;
        }
        if (status.status === 'offline') {
            if (docDetails.payment.values === 'yes' && !docDetails.payment.val) { showToast("Please enter the Payment value."); return false; }
            if (docDetails.stamp_paper.values === 'yes' && !docDetails.stamp_paper.val) { showToast("Please enter Stamp Paper details."); return false; }
        }
        if (estimatedCost && !/^[0-9/ ]+$/.test(estimatedCost)) {
            showToast("Estimated Cost must be numbers only."); return false;
        }
        return true;
    };

    // --- SUBMIT UPDATE ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateMandatory()) return;

        const isOnline = status.status === 'online';
            
        const docInfoRow = isOnline 
            ? `
              <p><strong>Certificate Copy Applicantion Status:</strong> ${docDetails.nlno.values?.toUpperCase() || 'PENDING'}</p>
              ${docDetails.nlno.values === 'yes' ? `<p><strong>Certificate Copy Applicantion No:</strong> ${docDetails.nlno.no}</p>` : ''}
            `
            : `
            <p><strong>Certificate Copy Applicantion Status:</strong> ${docDetails.nlno.values?.toUpperCase() || 'PENDING'}</p>
              <p><strong>Payment Status:</strong> ${docDetails.payment.values?.toUpperCase() || 'PENDING'}</p>
              ${docDetails.payment.values === 'yes' ? `<p><strong>Payment Value:</strong> ₹${docDetails.payment.val}</p>` : ''}
              <p><strong>Stamp Paper:</strong> ${docDetails.stamp_paper.values?.toUpperCase() || 'PENDING'}</p>
              ${docDetails.stamp_paper.values === 'yes' ? `<p><strong>Details:</strong> ${docDetails.stamp_paper.val}</p>` : ''}
            `;
        
        const summaryHtml = `
            <div style="text-align: left; font-size: 14px; color: #4a127e; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 2px solid #f0f0f0;">
                    <span style="font-size: 16px;"><strong># ${app_No}</strong></span>
                    <span style="background-color: ${isOnline ? '#8a2be2' : '#e7ac2d'}; color: white; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: bold; text-transform: uppercase;">
                        ${status.status}
                    </span>
                </div>
                
                <div style="background-color: #f9f7ff; padding: 10px; border-radius: 8px; margin-bottom: 10px;">
                    <p style="margin: 0;"><strong>Zone:</strong> ${(DATA.zones.find(z => String(z.id) === String(formData.zoneId))?.zoneName || 'N/A').toLowerCase()}</p>
                    <p style="margin: 0;"><strong>Office:</strong> ${(formOffices.find(o => String(o.id) === String(formData.officeId))?.officeName || 'N/A').toLowerCase()}</p>
                    <p style="margin: 0;"><strong>Managed By:</strong> ${users1.map(u => u.label).join(', ')}</p>
                </div>
        
                <p><strong>Referred By:</strong> ${ref?.value?.name?.toUpperCase() || 'DIRECT'}</p>
                <p><strong>Applicant:</strong> ${owner?.value?.name?.toUpperCase() || 'N/A'}</p>
                
                <div style="margin: 10px 0; padding: 10px; border: 1px dashed #8a2be2; border-radius: 8px;">
                    ${docInfoRow}
                    <p><strong>Certificate Copy Prepared:</strong> ${docDetails.nl_received.values?.toUpperCase() || 'PENDING'}</p>
                    <p><strong>Certificate Copy Delivered:</strong> ${docDetails.nl_delivered.values?.toUpperCase() || 'PENDING'}</p>
                </div>
        
                <p style="font-size: 15px; text-align: right; margin-top: 10px;">
                    <strong>Estimated Cost:</strong> <span style="color: #28a745; font-weight: bold;">${estimatedCost ? `₹${estimatedCost}` : '₹0'}</span>
                </p>
            </div>
        `;
        
        const result = await Swal.fire({
            title: 'Confirm Submission',
            html: summaryHtml, 
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#8a2be2",
        });
        
        if (!result.isConfirmed) return;
        setBt(true);

        const processClicks = (field) => {
            const current = docDetails[field];
            const originalVal = originalData[field]?.values|| null;
            return {
                values: current.values || "",
                no: current.no,
                val: current.val,
                clicked: current.values !== originalVal ? (current.clicked + 1) : current.clicked
            };
        };

        const data1 = {
            application_no: app_No,
            date: date,
            zone: (DATA.zones.find(z => String(z.id) === String(formData.zoneId))?.zoneName || "").toLowerCase(),
            register_office: (formOffices.find(o => String(o.id) === String(formData.officeId))?.officeName || "").toLowerCase(),
            managed_By: users1.map(u => u.value.toLowerCase()),
            refered_by: ref?.value || null,
            owner: owner?.value || null,
            status: status || null,
            estimated_cost: estimatedCost,
        };

        // Construct document payload
        const data = {
            nlno: processClicks('nlno'),
            payment: processClicks('payment'),
            stamp_paper: processClicks('stamp_paper'),
            nl_received: processClicks('nl_received'),
            nl_delivered: processClicks('nl_delivered'),
        };

        try {
            await api.patch(`/updateone_nl/${id}`, { data, data1 });
            Swal.fire({ text: 'Updated Successfully', icon: "success", width: "28em", timer: 2000, showConfirmButton: false });
            fetchNl();
            onclose();
            set_docedit(false);
            setDim(false);
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Unauthorized! Please login again."); 
                localStorage.removeItem("token"); 
                navigate("/login");
            } else {
                console.log(error);
            }
        } finally {
            setBt(false);
        }
    };

    const handleMsg = (type, payload) => { setActiveMsgText(MSGS[type](payload)); set_msg(true); setDim(true); };

    const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      borderRadius: '0.375rem',
      borderColor: state.isFocused ? 'var(--brand-purple)' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 1px var(--brand-purple)' : 'none',
      '&:hover': {
        borderColor: 'var(--brand-purple)'
      }
    }),
    // This ensures the menu is physically moved to the <body> 
    // so it ignores "overflow: hidden" on your Cards
    menuPortal: (base) => ({ 
      ...base, 
      zIndex: 9999 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected 
        ? 'var(--brand-purple)' 
        : state.isFocused 
        ? 'rgba(74, 18, 126, 0.1)' 
        : 'white',
      color: state.isSelected ? 'white' : 'var(--bs-body-color)',
    })
  };

  const validateCurrentStep = (stepToValidate = currentStep) => {
    switch (stepToValidate) {
        case 1:
            // --- Mandatory Application Details & Applicant Info ---
            if (!formData.zoneId) { showToast("Please select a Zone."); return false; }
            if (!formData.officeId) { showToast("Please select an Office."); return false; }
            if (!users1 || users1.length === 0) { showToast("Please assign at least one User."); return false; }
            break;

        case 2:
            // 1. Estimated Cost (Mandatory for both)
            // 2. Primary Conditional Fields (Online vs Offline)
            if (status.status === 'online') {
                if (docDetails.nlno.values === 'yes' && !docDetails.nlno.no) {
                    showToast("Please provide the NL Number.");
                    return false;
                }
            } else {
                if (docDetails.payment.values === 'yes' && !docDetails.payment.val) {
                    showToast("Please enter the Payment Value details.");
                    return false;
                }
                if (docDetails.stamp_paper.values === 'yes' && !docDetails.stamp_paper.val) {
                    showToast("Please enter the Stamp Paper Value.");
                    return false;
                }
            }
            break;

        // ... Keep your other cases (case 3, case 4, etc.) down here ...

        default:
            break;
    } 

    return true; // All checks passed, allows navigation
};

    return (
        <div className="editdoc container-xxl bg-light p-4 rounded shadow-lg" style={{ maxWidth: '1100px' }}>
            <ToastContainer />
            
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="text-secondary fw-bold mb-0">Edit Nagal (CCA) Registration</h3>
                <Button onClick={() => { set_docedit(false); setDim(false); }} variant="danger" className="rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '35px', height: '35px' }}>
                    <MdClose size={20} />
                </Button>
            </div>
            
            <SimpleBar style={{ width: '100%', height: '75vh' }} className="pe-3">
                {originalData && (
                    <Form onSubmit={handleSubmit} className="pb-4">
                        
                        {/* CONSTANT HEADER: Application Details */}
                        <Card className="shadow-sm border-0 mb-4 rounded-3 overflow-hidden" style={{ borderTop: '5px solid #e7ac2d' }}>
                        <Card.Header className="border-0 pt-4 px-4" style={{ backgroundColor: '#fffdf5' }}>
                            <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="fw-bold mb-0" style={{ color: "#4a127e", letterSpacing: '-0.3px' }}>
                                Application Details
                                </h5>
                                <p className="text-muted small mb-0">System identifiers and office assignment</p>
                            </div>
                            
                            {/* Refined Badge */}
                            <span className="badge rounded-pill px-3 py-2" style={{ backgroundColor: 'rgba(74, 18, 126, 0.1)', color: '#4a127e', fontSize: '11px' }}>
                                <i className="bi bi-clock-history me-1"></i>
                                Updated: {format(originalData?.updatedAt)}
                            </span>
                            </div>
                        </Card.Header>

                        <Card.Body className="px-4 pb-4" style={{ backgroundColor: '#fffdf5' }}>
                            <Row className="g-4">
                            {/* READ-ONLY FIELDS */}
                            <Form.Group as={Col} xs={12} sm={6} md={4}>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>Application No.</Form.Label>
                                <Form.Control 
                                type="text" 
                                value={app_No} 
                                readOnly 
                                className="bg-white border-0 shadow-none fw-bold" 
                                style={{ height: '42px', color: '#555' }} 
                                />
                            </Form.Group>

                            <Form.Group as={Col} xs={12} sm={6} md={4}>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>Date</Form.Label>
                                <Form.Control 
                                type="text" 
                                value={date} 
                                readOnly 
                                className="bg-white border-0 shadow-none fw-bold" 
                                style={{ height: '42px', color: '#555' }} 
                                />
                            </Form.Group>

                            {/* SELECT FIELDS */}
                            <Form.Group as={Col} xs={12} sm={6} md={4}>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>
                                Zone <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select 
                                className="shadow-none border-secondary-subtle fw-semibold" 
                                style={{ height: '42px', fontSize: '14px' }}
                                name="zoneId" 
                                disabled={user.role === 'user'} 
                                value={formData.zoneId || ""} 
                                onChange={handleChange}
                                >
                                <option value="">-- Choose Zone --</option>
                                {[...DATA.zones].sort((a, b) => a.zoneName.localeCompare(b.zoneName)).map((z) => (<option key={z.id} value={z.id}>{z.zoneName.toUpperCase()}</option>))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group as={Col} xs={12} sm={6} md={4}>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>
                                Office <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select 
                                className="shadow-none border-secondary-subtle fw-semibold" 
                                style={{ height: '42px', fontSize: '14px' }}
                                name="officeId" 
                                disabled={user.role === 'user' || !formData.zoneId} 
                                value={formData.officeId || ""} 
                                onChange={handleChange}
                                >
                                <option value="">-- Choose Office --</option>
                                {[...formOffices].sort((a, b) => a.officeName.localeCompare(b.officeName)).map((o) => (<option key={o.id} value={o.id}>{o.officeName.toUpperCase()}</option>))}
                                </Form.Select>
                            </Form.Group>

                            {/* REACT SELECT MULTI */}
                            <Form.Group as={Col} xs={12} md={8}>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>
                                Managed By <span className="text-danger">*</span>
                                </Form.Label>
                                <Select 
                                isClearable 
                                isMulti 
                                isDisabled={user.role === "user"} 
                                options={option_User || []} 
                                value={users1 || []} 
                                placeholder="Select staff names..." 
                                onChange={(val) => set_users(val ? [...val] : [])}
                                
                                // Essential UI fixes for React Select
                                styles={selectStyles}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                />
                            </Form.Group>
                            </Row>
                        </Card.Body>
                        </Card>

                        {/* STEPPER VISUAL */}
                        <div className="d-flex justify-content-center align-items-center mb-5 px-3 py-3 overflow-auto custom-scrollbar">
                        {[
                            { id: 1, label: "Applicant Info", complete: isStep1Complete },
                            { id: 2, label: "Document Process", complete: isStep2Complete },
                            // You can easily add more steps here without extra HTML
                        ].map((step, index, array) => (
                            <React.Fragment key={step.id}>
                            
                            {/* --- STEP NODE --- */}
                            <div 
                                className="d-flex flex-column align-items-center position-relative" 
                                style={{ cursor: 'pointer', minWidth: '120px' }}
                                 onClick={()=>{
                  if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(currentStep === 1 ? 2 : 1 )
                }}>
                                <div style={{
                                width: '42px', height: '42px', borderRadius: '50%',
                                display: 'flex', justifyContent: 'center', alignItems: 'center', 
                                fontWeight: 'bold', fontSize: '18px', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                
                                // Halo effect for the active step
                                boxShadow: currentStep === step.id ? '0 0 0 5px rgba(138, 43, 226, 0.2)' : 'none',
                                
                                // Dynamic Colors Logic
                                backgroundColor: step.complete ? '#8a2be2' : (currentStep === step.id ? '#ece917' : '#f8f9fa'),
                                color: step.complete ? '#ece917' : (currentStep === step.id ? '#4a127e' : '#adb5bd'),
                                border: (step.complete || currentStep === step.id) ? '2px solid #8a2be2' : '2px solid #dee2e6',
                                
                                zIndex: 2,
                                // Subtle pop effect on active
                                transform: currentStep === step.id ? 'scale(1.1)' : 'scale(1)'
                                }}>
                                {step.complete ? '✓' : step.id}
                                </div>
                                
                                <span className="mt-2 fw-bold text-center text-uppercase" style={{ 
                                fontSize: '10px', 
                                letterSpacing: '0.5px',
                                color: step.complete || currentStep === step.id ? '#4a127e' : '#adb5bd',
                                transition: 'color 0.3s',
                                maxWidth: '100px'
                                }}>
                                {step.label}
                                </span>
                            </div>

                            {/* --- DYNAMIC CONNECTOR LINE --- */}
                            {index < array.length - 1 && (
                                <div style={{ 
                                flex: '1', 
                                maxWidth: '120px', 
                                minWidth: '40px',
                                height: '4px', 
                                borderRadius: '2px',
                                backgroundColor: '#e9ecef', 
                                margin: '0 -10px', // Pulls nodes closer for better flow
                                marginBottom: '20px', // Precision alignment with circle center
                                position: 'relative',
                                overflow: 'hidden',
                                zIndex: 1
                                }}>
                                <motion.div 
                                    initial={false}
                                    animate={{ width: step.complete ? '100%' : '0%' }} 
                                    transition={{ duration: 0.5, ease: "easeInOut" }}
                                    style={{ height: '100%', backgroundColor: '#8a2be2' }} 
                                />
                                </div>
                            )}
                            </React.Fragment>
                        ))}
                        </div>

                        {/* STEP 1: Applicant Info */}
                        {currentStep === 1 && (
                            <motion.div 
                                initial={{ opacity: 0, x: -20 }} 
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                                <Card.Header className="bg-white border-0 pt-4 px-4">
                                    <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>
                                    Reference & Executant Details
                                    </h5>
                                    <p className="text-muted small mb-0">Identify the referring party and the primary applicant.</p>
                                </Card.Header>
                                
                                <Card.Body className="px-4 pb-4">
                                    {/* --- SECTION: REFERRED BY --- */}
                                    <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #8a2be2' }}>
                                    <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#8a2be2', letterSpacing: '0.5px' }}>
                                        <i className="bi bi-person-badge me-2"></i>Referred By
                                    </h6>
                                    <Row className="g-3">
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                        <CreatableSelect 
                                            isClearable 
                                            isDisabled={user.role === 'user'} 
                                            value={ref} 
                                            options={options || []} 
                                            onCreateOption={() => { setAdd(true); setDim(true); }} 
                                            placeholder="Search..." 
                                            onChange={set_ref} 
                                            styles={selectStyles}
                                            menuPortalTarget={document.body} 
                                        />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                                        <Form.Control readOnly value={TitleCase(ref?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                                        <Form.Control readOnly value={TitleCase(ref?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                                        <Form.Control readOnly value={ref?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                    </Row>
                                    </div>

                                    {/* --- SECTION: EXECUTANT (APPLICANT) --- */}
                                    <div className="p-3 rounded-3" style={{ backgroundColor: '#fffdf5', borderLeft: '4px solid #e7ac2d' }}>
                                    <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#4a127e', letterSpacing: '0.5px' }}>
                                        <i className="bi bi-person-check me-2"></i>Executant (Applicant)
                                    </h6>
                                    <Row className="g-3">
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                        <CreatableSelect 
                                            isClearable 
                                            isDisabled={user.role === 'user'} 
                                            value={owner} 
                                            options={options || []} 
                                            onCreateOption={() => { setAdd(true); setDim(true); }} 
                                            placeholder="Search..." 
                                            onChange={set_Owner} 
                                            styles={selectStyles}
                                            menuPortalTarget={document.body}
                                        />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                                        <Form.Control readOnly value={TitleCase(owner?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                                        <Form.Control readOnly value={TitleCase(owner?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                        <Form.Group as={Col} xs={12} sm={6} md={3}>
                                        <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                                        <Form.Control readOnly value={owner?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                                        </Form.Group>
                                    </Row>
                                    </div>
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}

                        {/* STEP 2: Document Details */}
                        {currentStep === 2 && (
                            <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }}>
                                <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                                {/* HEADER WITH MODE SWITCH */}
                                <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                                    <div>
                                    <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>Document Process</h5>
                                    <p className="text-muted small mb-0">Manage Certificate Copy (CCA) workflows</p>
                                    </div>
                                    
                                    <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                        <Typography sx={{ fontSize: '11px', color: status.status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Offline</Typography>
                                        <AntSwitch 
                                        checked={status.status === 'online'} 
                                        onChange={(e) => setStatus({ ...status, click: status.click + 1, status: e.target.checked ? 'online' : 'offline' })} 
                                        disabled={user.role === "user"} 
                                        />
                                        <Typography sx={{ fontSize: '11px', color: status.status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Online</Typography>
                                    </Stack>
                                    </div>
                                </Card.Header>

                                <Card.Body className="px-4 pb-4">
                                    <Row className="g-4">
                                    
                                    {/* CCA APPLICATION SECTION */}
                                    <Col xs={12} md={4}>
                                        <div className={`p-3 rounded-3 border h-100 ${docDetails.nlno.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                            CCA Application {status.status === "online" && "No."}
                                            </Form.Label>
                                            <div className="mb-2">
                                            <ThreeStateToggle 
                                                value={docDetails.nlno.values} 
                                                onChange={(val) => handleDocToggleChange('nlno', val)} 
                                                disabled={!canToggle('nlno')} 
                                            />
                                            </div>
                                            
                                            {docDetails.nlno.values === 'yes' && (
                                            <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }}>
                                                <Button 
                                                size="sm" 
                                                className="w-100 py-1 fw-bold rounded-pill mb-3 shadow-sm border-0" 
                                                style={{backgroundColor: '#8a2be2', fontSize: '11px'}}
                                                onClick={() => handleMsg((status.status === "online"?'WELCOME1':'WELCOME2'), { 
                                                    app_no: app_No, 
                                                    document_number: `CCA/${status.status === 'online' ? 'Online' : 'Offline'}/${docDetails.nlno.no || 'PENDING'}/${date.split("-")[2]}` 
                                                })}
                                                >
                                                <i className="bi bi-chat-left-text me-2"></i>Copy Welcome Msg
                                                </Button>

                                                {status.status === "online" && (
                                                <Form.Control 
                                                    className="shadow-none fw-bold" 
                                                    value={docDetails.nlno.no || ''} 
                                                    onChange={(e) => setDocDetails(p => ({ ...p, nlno: { ...p.nlno, no: e.target.value } }))} 
                                                    type="number" 
                                                    placeholder="ECA Number..." 
                                                />
                                                )}
                                            </motion.div>
                                            )}
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* OFFLINE ONLY: PAYMENT & STAMP PAPER */}
                                    {status.status === "offline" && (
                                        <>
                                        <Col xs={12} md={4}>
                                            <div className="p-3 rounded-3 border h-100 bg-light border-warning-subtle">
                                            <Form.Group>
                                                <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Payment Details</Form.Label>
                                                <div className="mb-2">
                                                <ThreeStateToggle value={docDetails.payment.values} onChange={(val) => handleDocToggleChange('payment', val)} disabled={!canToggle('payment')} />
                                                </div>
                                                {docDetails.payment.values === 'yes' && (
                                                <div className="input-group input-group-sm mt-3">
                                                    <span className="input-group-text bg-white text-muted border-end-0">₹</span>
                                                    <Form.Control className="shadow-none border-start-0 fw-bold" value={docDetails.payment.val || ''} onChange={(e) => setDocDetails(p => ({ ...p, payment: { ...p.payment, val: e.target.value } }))} type="number" placeholder="Value" />
                                                </div>
                                                )}
                                            </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={4}>
                                            <div className="p-3 rounded-3 border h-100 bg-light border-warning-subtle">
                                            <Form.Group>
                                                <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Stamp Paper</Form.Label>
                                                <div className="mb-2">
                                                <ThreeStateToggle value={docDetails.stamp_paper.values} onChange={(val) => handleDocToggleChange('stamp_paper', val)} disabled={!canToggle('stamp_paper')} />
                                                </div>
                                                {docDetails.stamp_paper.values === 'yes' && (
                                                <Form.Control size="sm" className="mt-3 shadow-none fw-bold" value={docDetails.stamp_paper.val || ''} onChange={(e) => setDocDetails(p => ({ ...p, stamp_paper: { ...p.stamp_paper, val: e.target.value } }))} type="text" placeholder="Enter Details..." />
                                                )}
                                            </Form.Group>
                                            </div>
                                        </Col>
                                        </>
                                    )}

                                    {/* PREPARED & DELIVERED */}
                                    <Col xs={12} md={4}>
                                        <div className={`p-3 rounded-3 border h-100 ${docDetails.nl_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">CCA Prepared</Form.Label>
                                            <div className="mb-2">
                                            <ThreeStateToggle value={docDetails.nl_received.values} onChange={(val) => handleDocToggleChange('nl_received', val)} disabled={!canToggle('nl_received')} />
                                            </div>
                                            {docDetails.nl_received.values === 'yes' && (
                                            <Button 
                                                size="sm" 
                                                className="w-100 py-1 fw-bold rounded-pill mt-2 shadow-sm border-0" 
                                                style={{backgroundColor: '#198754', fontSize: '11px'}}
                                                onClick={() => handleMsg((status.status === "online"?'COLLECTED':'COLLECTED1'), { 
                                                app_no: app_No, 
                                                document_number: `CCA/${status.status === 'online' ? 'Online' : 'Offline'}/${docDetails.nlno.no || 'PENDING'}/${date.split("-")[2]}`, 
                                                office: formOffices.find(o => o.id === formData.officeId)?.officeName?.toUpperCase() 
                                                })}
                                            >
                                                <i className="bi bi-check2-circle me-2"></i>Copy Ready Msg
                                            </Button>
                                            )}
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    <Col xs={12} md={4}>
                                        <div className={`p-3 rounded-3 border h-100 ${docDetails.nl_delivered.values === 'yes' ? 'bg-light border-info-subtle' : 'bg-white'}`}>
                                        <Form.Group>
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">CCA Delivered</Form.Label>
                                            <div className="mb-2">
                                            <ThreeStateToggle value={docDetails.nl_delivered.values} onChange={(val) => handleDocToggleChange('nl_delivered', val)} disabled={!canToggle('nl_delivered')} />
                                            </div>
                                        </Form.Group>
                                        </div>
                                    </Col>

                                    {/* COST & FINAL ACTION */}
                                    <Col xs={12} md={4}>
                                        <div className="p-3 rounded-3 border bg-white h-100 shadow-sm border-warning-subtle">
                                        <Form.Group className="mb-3">
                                            <Form.Label className="small fw-bold text-muted text-uppercase mb-1">Estimated Cost (₹)</Form.Label>
                                            <Form.Control 
                                            className="shadow-none border-0 bg-light fw-bold"
                                            value={estimatedCost} 
                                            onChange={(e) => setEstimatedCost(e.target.value)} 
                                            type="number" 
                                            placeholder="0.00" 
                                            />
                                        </Form.Group>
                                        <Button 
                                            variant="outline-primary" 
                                            className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                                            style={{color: '#4a127e', borderColor: '#dbe72d', borderWidth: '2px'}} 
                                            onClick={() => handleMsg((status.status === "online"?'THANK':'THANK1'), { 
                                            app_no: app_No, 
                                            document_number: `CCA/${status.status === 'online' ? 'Online' : 'Offline'}/${docDetails.nlno.no || 'PENDING'}/${date.split("-")[2]}` 
                                            })}
                                        >
                                            <i className="bi bi-stars me-2"></i>Send Thank You
                                        </Button>
                                        </div>
                                    </Col>
                                    </Row>
                                </Card.Body>
                                </Card>
                            </motion.div>
                            )}

                        {/* NAVIGATION BUTTONS */}
                        <div className="d-flex justify-content-between mt-4">
                            <Button variant="secondary" size="lg" className="px-4 shadow-sm" onClick={() => {
                                                            if(!validateCurrentStep(2)) return;
                                                            setCurrentStep(1)
                                                        }} disabled={currentStep === 1 || bt}>Back</Button>
                                                        <div className="d-flex gap-3">
                                                            {currentStep === 1 && (
                                                                <Button style={{ backgroundColor: '#8a2be2', borderColor: '#8a2be2' }} size="lg" className="text-white px-5 shadow-sm" onClick={() =>{ 
                                                                    if(!validateCurrentStep(1)) return;
                                                                    setCurrentStep(2)}}>Next Step</Button>
                                                            )}
                                                            <Button style={{ backgroundColor: '#e7ac2d', borderColor: '#e7ac2d', color: '#fff' }} size="lg" className="px-5 shadow-sm fw-bold" disabled={bt} type="submit">
                                                                {bt ? 'Saving...' : 'Save Changes'}
                                                            </Button>
                                                        </div>
                        </div>
                    </Form>
                )}
            </SimpleBar>

            {/* Background Modals */}
            <AnimatePresence>
                {add && (
                    <motion.div key="add-client" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} className="modal-overlay-wrapper">
                        <AddClient setAdd={setAdd} showToast={showToast} get_customer={fetchClients} />
                    </motion.div>
                )}
                {msg && (
                    <motion.div key="copy-msg" initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} style={{ position: 'fixed', bottom: '40px', left: '0', right: '0', zIndex: 3000, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
                        <div style={{ pointerEvents: 'auto' }}><CopyMsg set_msg={set_msg} content={activeMsgText} /></div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};